import type { BoundActions, HookActionsFunction, HookFunction } from 'react-sweet-state';
import { createHook, createStore, createActionsHook } from 'react-sweet-state';

const initialState = {
	isHelpCenterOpen: false,
	isHelpCenterManuallyOpened: false,
	shouldShowHelpMenuSpotlight: null,
	isFeatureDiscovered: false,
};

export const actions = {
	openHelpCenter:
		(isHelpCenterManuallyOpened: boolean = false) =>
		({ setState }: { setState: any }): void => {
			setState({ isHelpCenterOpen: true, isHelpCenterManuallyOpened });
		},
	closeHelpCenter:
		() =>
		({ setState }: { setState: any }): void => {
			setState({ isHelpCenterOpen: false, isHelpCenterManuallyOpened: false });
		},
	showHelpMenuSpotlight:
		() =>
		({ setState }: { setState: any }): void => {
			setState({ shouldShowHelpMenuSpotlight: true });
		},
	hideHelpMenuSpotlight:
		() =>
		({ setState }: { setState: any }): void => {
			setState({ shouldShowHelpMenuSpotlight: false });
		},
	setFeatureDiscovered:
		(discoveryState: boolean) =>
		({ setState }: { setState: any }): void => {
			setState({ isFeatureDiscovered: discoveryState });
		},
};

const store = createStore({
	initialState,
	actions,
});

export const useHelpMenuState: HookFunction<
	{
		isHelpCenterOpen: boolean;
		isHelpCenterManuallyOpened: boolean;
		shouldShowHelpMenuSpotlight: null;
		isFeatureDiscovered: boolean;
	},
	BoundActions<
		{
			isHelpCenterOpen: boolean;
			isHelpCenterManuallyOpened: boolean;
			shouldShowHelpMenuSpotlight: null;
			isFeatureDiscovered: boolean;
		},
		{
			openHelpCenter: (
				isHelpCenterManuallyOpened?: boolean,
			) => ({ setState }: { setState: any }) => void;
			closeHelpCenter: () => ({ setState }: { setState: any }) => void;
			showHelpMenuSpotlight: () => ({ setState }: { setState: any }) => void;
			hideHelpMenuSpotlight: () => ({ setState }: { setState: any }) => void;
			setFeatureDiscovered: (discoveryState: boolean) => ({ setState }: { setState: any }) => void;
		}
	>,
	void
> = createHook(store);
export const useHelpMenuActions: HookActionsFunction<
	BoundActions<
		{
			isHelpCenterOpen: boolean;
			isHelpCenterManuallyOpened: boolean;
			shouldShowHelpMenuSpotlight: null;
			isFeatureDiscovered: boolean;
		},
		{
			openHelpCenter: (
				isHelpCenterManuallyOpened?: boolean,
			) => ({ setState }: { setState: any }) => void;
			closeHelpCenter: () => ({ setState }: { setState: any }) => void;
			showHelpMenuSpotlight: () => ({ setState }: { setState: any }) => void;
			hideHelpMenuSpotlight: () => ({ setState }: { setState: any }) => void;
			setFeatureDiscovered: (discoveryState: boolean) => ({ setState }: { setState: any }) => void;
		}
	>
> = createActionsHook(store);
